import { render, staticRenderFns } from "./SearchBlogs.vue?vue&type=template&id=8b173b2c&scoped=true&"
import script from "./SearchBlogs.vue?vue&type=script&lang=js&"
export * from "./SearchBlogs.vue?vue&type=script&lang=js&"
import style0 from "./SearchBlogs.vue?vue&type=style&index=0&id=8b173b2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b173b2c",
  null
  
)

export default component.exports